function applyTimeZoneDifference(date: string, offset: number): Date {
    let output = new Date(date)
    output.setMinutes(output.getMinutes() + offset)
    return output
}

//sets the end date to the first minute of the subsequent day in UTC
//you would want to get everything that happened on a day if you're selecting it as your end date
export function adjustEndDate(date: string): string {
    let newEnd = new Date(date)
    newEnd.setDate(newEnd.getDate() + 1)
    return newEnd.toISOString().substring(0, 10)
}

function convertToMSSQLDateTime(date: Date): string {
    return date.toISOString().slice(0, 19).replace('T', ' ')
}

export function applyDateProcessingMethods(date: string, offset: number): string {
    let timezoneAdjustedDate = applyTimeZoneDifference(date, offset)
    let sqlDatetime = convertToMSSQLDateTime(timezoneAdjustedDate)
    return sqlDatetime
}

export const timezones = [
    {
        name: 'Philippines',
        value: -480,
    },
    {
        name: 'UTC',
        value: 0,
    },
    {
        name: 'Salt Lake City',
        value: 360,
    },
]
